/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Glass
 *| (C) Copyright IBM Corp. 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'../../nls/StringResources',
	'text!../views/templates/AboutDialog.html',
	'doT'
], function(StringResources, template, dot) {

	class OpenAboutCognosAction {

		canExecute() {
			return true;
		}

		doAction(context) {
			return this._showTheAboutDialog(context);
		}

		_options(productVersion, kitVersion) {
			return {
				aboutCognosAnalytics: StringResources.get('legalText', { 'year': new Date().getFullYear() }),
				cognosLabel: StringResources.get('productName', {
					'version': productVersion
				}),
				kitVersion: kitVersion,
				svgIcon: 'common-CA_Avatar_Colour_24'
			};
		}

		_showTheAboutDialog(context) {
			return context.glassContext.getCoreSvc('.Config').getProductVersion().then(productVersion => {
				const html = dot.template(template || '')(this._options(productVersion, context.glassContext.versionInfo));
				return context.glassContext.appController.showMessage(html, '', 'info', ['close'], '399px', undefined, true, 'aboutDialog');
			});
		}
	}

	return OpenAboutCognosAction;
});
